<template>
    <b-card no-body>
        <b-modal id="seyir-driver-info" size="lg" title="Seyir Sürücü Dosya İndirme Takip — Kullanım" hide-footer centered>
            <div class="mb-75">
                <b>Bu ekran ne işe yarar?</b>
                <p class="mb-50">Aktif sürücülerin Seyir servisinden takograf dosyalarının <b>günlük olarak otomatik</b> indirilme durumunu, ay bazlı bir matris olarak gösterir. Her hücre bir sürücünün o günkü son sorgu sonucunu temsil eder.</p>
            </div>
            <div class="mb-75">
                <b>Filtreler ve sorgu</b>
                <ul class="pl-1 mb-50">
                    <li><b>Ay / Yıl:</b> İzlemek istediğin dönemi seç, <b>Sorgula</b>'ya bas.</li>
                    <li><b>Durum filtresi:</b> "Sadece hatalı günü olanlar", "Dosya indirilemeyen", "Yapılandırması eksik" gibi kırılımlarla listeyi daraltır.</li>
                    <li><b>Arama kutusu:</b> Sürücü adına göre filtreler.</li>
                </ul>
            </div>
            <div class="mb-75">
                <b>KPI kartları</b>
                <p class="mb-50">Ekranın üstündeki şerit <b>bugüne ait</b> durum özetini gösterir — ay geneli değil. Önceki aylara baktığında tüm sayılar 0 olur, bu normaldir.</p>
            </div>
            <div class="mb-75">
                <b>Hücre ikonları</b>
                <p class="mb-50">Lejanttaki her ikon bir günün durumunu temsil eder. <span class="font-weight-bolder">Yeşil check</span> = dosya indirildi ve takograf işlendi. <span class="font-weight-bolder">Sarı download_done</span> = dosya indirildi fakat takograf işlenemedi. <span class="font-weight-bolder">Mavi task_alt</span> = dosya geçmişte zaten indirilmiş (Seyir ikinci kez vermiyor). Kırmızı ikonlar hataları, gri ikonlar bilgi durumlarını gösterir.</p>
            </div>
            <div class="mb-75">
                <b>Hücreye tıklayınca</b>
                <p class="mb-50">Detay penceresi açılır; o güne ait tüm sorgu log'larını, servis mesajını, ve varsa <b>Dosyayı İndir</b> butonunu görebilirsin. Bugünkü sütundaki bir hücrede <b>Yeniden Sorgula</b> butonu ile sorguyu anında tetikleyebilirsin (Seyir servisi her zaman en güncel dosyayı döndürür, tarihe göre seçim yapılamaz).</p>
            </div>
            <div class="mb-75">
                <b>Özet kolonu</b>
                <p class="mb-50">Sürücü adının yanındaki "X / Y" rozeti ay içindeki başarılı gün sayısını/beklenen gün sayısını gösterir. Yeşil = ≥%90, sarı = ≥%60, kırmızı = altı.</p>
            </div>
            <div class="mb-75">
                <b>Excel</b>
                <p class="mb-0">Sağ üstteki <b>Excel</b> butonu, aktif filtre ile tüm sayfaları içeren renkli bir rapor üretir.</p>
            </div>
        </b-modal>

        <b-modal id="seyir-bulk-retrigger" size="xl" body-class="p-0" title="Bugünün Hatalı Sorgularını Yeniden Çalıştır" :no-close-on-esc="bulkRunning" :no-close-on-backdrop="bulkRunning" :hide-header-close="bulkRunning" v-on:hidden="onBulkModalHidden">
            <div v-if="bulkLoading" class="text-center py-3">
                <b-spinner variant="primary"></b-spinner>
                <div class="mt-75 text-muted">Hatalı sürücüler yükleniyor...</div>
            </div>
            <template v-else>
                <div v-if="bulkItems.length === 0" class="text-center py-3">
                    <span class="material-icons-outlined text-success" style="font-size:3rem">verified</span>
                    <div class="font-weight-bolder mt-50">Hiçbir hatalı sorgu bulunamadı.</div>
                    <div class="text-muted">Bugün için yeniden sorgulanacak bir kayıt yok.</div>
                </div>
                <template v-else>
                    <!-- Hero / Action panel -->
                    <div class="seyir-bulk-hero p-1 p-md-2">
                        <div class="d-flex flex-wrap align-items-center">
                            <div class="mr-auto">
                                <div class="seyir-bulk-hero-title">
                                    <span class="material-icons-outlined align-middle mr-25">replay</span>
                                    {{ bulkAllDone ? 'İşlem Tamamlandı' : bulkRunning ? 'Sorgular Çalıştırılıyor' : 'Yeniden Sorgulamaya Hazır' }}
                                </div>
                                <div class="seyir-bulk-hero-subtitle">
                                    <b>{{ bulkItems.length }}</b> hatalı sürücü bulundu.
                                    <span v-if="bulkAllDone">Tüm sorgular işlendi (%{{ bulkProgressPercent }}).</span>
                                    <span v-else-if="bulkRunning">{{ bulkProcessedCount }} / {{ bulkItems.length }} işlendi (%{{ bulkProgressPercent }}), {{ bulkItems.length - bulkProcessedCount }} bekliyor.</span>
                                    <span v-else>Başlatmak için sağdaki butona bas.</span>
                                </div>
                            </div>
                            <div class="seyir-bulk-hero-actions">
                                <button v-if="!bulkRunning && bulkProcessedCount < bulkItems.length" class="btn btn-primary" v-on:click="runBulk">
                                    <span class="material-icons-outlined align-middle mr-25" style="font-size:1.1rem">play_arrow</span>
                                    {{ bulkProcessedCount > 0 ? 'Kalanları Çalıştır' : 'Başlat' }}
                                </button>
                                <button v-if="bulkRunning" class="btn btn-outline-danger" v-on:click="cancelBulk">
                                    <span class="material-icons-outlined align-middle mr-25" style="font-size:1.1rem">stop</span>
                                    Durdur
                                </button>
                            </div>
                        </div>

                        <!-- Progress bar -->
                        <div class="progress seyir-bulk-progress mt-1">
                            <div class="progress-bar" :class="bulkRunning ? 'progress-bar-striped progress-bar-animated bg-primary' : (bulkAllDone ? 'bg-success' : 'bg-primary')" :style="{ width: bulkProgressPercent + '%' }"></div>
                        </div>

                        <!-- Stat chips -->
                        <div class="d-flex flex-wrap mt-1 seyir-bulk-chips">
                            <div class="seyir-bulk-chip seyir-bulk-chip-total">
                                <span class="material-icons-outlined">groups</span>
                                <div>
                                    <div class="seyir-bulk-chip-value">{{ bulkItems.length }}</div>
                                    <div class="seyir-bulk-chip-label">Toplam</div>
                                </div>
                            </div>
                            <div class="seyir-bulk-chip seyir-bulk-chip-success">
                                <span class="material-icons-outlined">check_circle</span>
                                <div>
                                    <div class="seyir-bulk-chip-value">{{ bulkSuccessCount }}</div>
                                    <div class="seyir-bulk-chip-label">Başarılı</div>
                                </div>
                            </div>
                            <div class="seyir-bulk-chip seyir-bulk-chip-fail">
                                <span class="material-icons-outlined">error_outline</span>
                                <div>
                                    <div class="seyir-bulk-chip-value">{{ bulkFailCount }}</div>
                                    <div class="seyir-bulk-chip-label">Başarısız</div>
                                </div>
                            </div>
                            <div class="seyir-bulk-chip seyir-bulk-chip-pending">
                                <span class="material-icons-outlined">schedule</span>
                                <div>
                                    <div class="seyir-bulk-chip-value">{{ bulkItems.length - bulkProcessedCount }}</div>
                                    <div class="seyir-bulk-chip-label">Bekleyen</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Driver list -->
                    <div class="seyir-bulk-list">
                        <div v-for="(item, index) in bulkItems" :key="item.EmployeeId" class="seyir-bulk-row" :class="bulkRowClass(item)">
                            <div class="seyir-bulk-row-index">{{ index + 1 }}</div>
                            <div class="seyir-bulk-row-state-icon">
                                <span v-if="item.State === 'pending'" class="material-icons-outlined text-muted">schedule</span>
                                <b-spinner v-else-if="item.State === 'running'" small variant="primary"></b-spinner>
                                <span v-else-if="item.State === 'success'" class="material-icons-outlined text-success">check_circle</span>
                                <span v-else-if="item.State === 'fail'" class="material-icons-outlined text-danger">cancel</span>
                            </div>
                            <div class="seyir-bulk-row-driver">
                                <div class="seyir-bulk-row-name">{{ item.FullName }}</div>
                                <div class="seyir-bulk-row-meta">
                                    <span class="mr-75"><b>TC:</b> {{ item.IdentityNumber }}</span>
                                    <span><b>DataId:</b> {{ item.SeyirDriverDataId || '-' }}</span>
                                </div>
                            </div>
                            <div class="seyir-bulk-row-status">
                                <div class="seyir-bulk-row-status-old">
                                    <span class="text-muted small">Eski:</span>
                                    <span class="badge badge-light-danger ml-25">{{ item.DayStatusLabel }}</span>
                                </div>
                                <div v-if="item.ServiceMessage" class="text-muted small text-truncate" :title="item.ServiceMessage">{{ item.ServiceMessage }}</div>
                            </div>
                            <div class="seyir-bulk-row-result">
                                <template v-if="item.State === 'pending'">
                                    <span class="badge badge-light-secondary">Bekliyor</span>
                                </template>
                                <template v-else-if="item.State === 'running'">
                                    <span class="badge badge-light-primary">
                                        <b-spinner small></b-spinner>
                                        <span class="ml-25">Sorgulanıyor</span>
                                    </span>
                                </template>
                                <template v-else-if="item.State === 'success'">
                                    <span class="badge badge-light-success">
                                        <span class="material-icons-outlined align-middle" style="font-size:0.9rem">check</span>
                                        Başarılı
                                    </span>
                                    <div v-if="item.Message" class="small text-muted mt-25" :title="item.Message">{{ item.Message }}</div>
                                </template>
                                <template v-else-if="item.State === 'fail'">
                                    <span class="badge badge-light-danger">
                                        <span class="material-icons-outlined align-middle" style="font-size:0.9rem">close</span>
                                        Başarısız
                                    </span>
                                    <div v-if="item.Message" class="small text-danger mt-25" :title="item.Message">{{ item.Message }}</div>
                                </template>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
            <template #modal-footer>
                <div v-if="bulkAllDone" class="mr-auto text-muted small">
                    Tablo kapanışta otomatik yenilenecek.
                </div>
                <button class="btn btn-secondary" :disabled="bulkRunning" v-on:click="$bvModal.hide('seyir-bulk-retrigger')">
                    {{ bulkAllDone ? 'Tamam' : 'Kapat' }}
                </button>
            </template>
        </b-modal>

        <v-table ref="table" :items-provider="provider" pagination="server" search :fields="fields" v-on:refresh="onTableResfreh" :initial-load="false">
            <template #custom-html>
                <div class="mx-1 mb-1">
                    <div class="seyir-legend d-flex flex-wrap">
                        <span class="seyir-legend-item bg-light-success"><span class="material-icons-outlined">check_circle</span>Başarılı</span>
                        <span class="seyir-legend-item bg-light-warning"><span class="material-icons-outlined">download_done</span>İndirildi - İşlenemedi</span>
                        <span class="seyir-legend-item bg-light-primary"><span class="material-icons-outlined">task_alt</span>Zaten İndirilmiş</span>
                        <span class="seyir-legend-item bg-light-danger"><span class="material-icons-outlined">sync_problem</span>Sorgu Başarısız</span>
                        <span class="seyir-legend-item bg-light-danger"><span class="material-icons-outlined">cloud_off</span>Dosya İndirilemedi</span>
                        <span class="seyir-legend-item bg-light-warning"><span class="material-icons-outlined">schedule</span>Sorgu Yapılmadı</span>
                        <span class="seyir-legend-item bg-light-secondary"><span class="material-icons-outlined">settings</span>Yapılandırma Eksik</span>
                        <span class="seyir-legend-item bg-light-info"><span class="material-icons-outlined">event_busy</span>İzinli</span>
                        <span class="seyir-legend-item bg-light"><span class="material-icons-outlined">event</span>Gelecek Tarih</span>
                        <span class="seyir-legend-item bg-light"><span class="material-icons-outlined">remove_circle_outline</span>Çalışmıyor</span>
                    </div>

                    <div v-if="summary" class="row mt-50 mb-1">
                        <div class="col-12">
                            <div class="d-flex flex-wrap align-items-center seyir-kpi-band p-75 rounded bg-light">
                                <div class="seyir-kpi-item">
                                    <div class="seyir-kpi-label seyir-kpi-title">
                                        <span class="material-icons-outlined align-middle mr-25" style="font-size:0.95rem">today</span>
                                        Bugün ({{ todayLabel }})
                                    </div>
                                </div>
                                <div class="seyir-kpi-item">
                                    <div class="seyir-kpi-value">{{ summary.FilteredEmployees }}<small class="text-muted"> / {{ summary.TotalEmployees }}</small></div>
                                    <div class="seyir-kpi-label">Sürücü</div>
                                </div>
                                <div class="seyir-kpi-item text-success">
                                    <div class="seyir-kpi-value">{{ summary.SuccessfulDays }}</div>
                                    <div class="seyir-kpi-label">Başarılı</div>
                                </div>
                                <div class="seyir-kpi-item text-warning">
                                    <div class="seyir-kpi-value">{{ summary.DownloadedNotProcessedDays }}</div>
                                    <div class="seyir-kpi-label">İşlenemedi</div>
                                </div>
                                <div class="seyir-kpi-item text-primary">
                                    <div class="seyir-kpi-value">{{ summary.FileAlreadyDownloadedDays }}</div>
                                    <div class="seyir-kpi-label">Zaten İndirilmiş</div>
                                </div>
                                <div class="seyir-kpi-item text-danger">
                                    <div class="seyir-kpi-value">{{ summary.DownloadFailedDays + summary.QueryFailedDays }}</div>
                                    <div class="seyir-kpi-label">Hatalı</div>
                                </div>
                                <div class="seyir-kpi-item text-warning">
                                    <div class="seyir-kpi-value">{{ summary.NotQueriedDays }}</div>
                                    <div class="seyir-kpi-label">Sorgulanmadı</div>
                                </div>
                                <div class="seyir-kpi-item text-secondary">
                                    <div class="seyir-kpi-value">{{ summary.NotConfiguredDays }}</div>
                                    <div class="seyir-kpi-label">Yapılandırma Eksik</div>
                                </div>
                                <div class="seyir-kpi-item text-info">
                                    <div class="seyir-kpi-value">{{ summary.ExcusedDays }}</div>
                                    <div class="seyir-kpi-label">İzinli</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template #additional-actions>
                <div class="seyir-action-bar d-flex flex-wrap align-items-center">
                    <div class="seyir-action-group d-flex flex-wrap align-items-center mr-auto">
                        <select class="form-control seyir-select-sm mr-50 mb-50 mb-md-0" v-model="month">
                            <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                        </select>
                        <select class="form-control seyir-select-sm mr-50 mb-50 mb-md-0" v-model="year">
                            <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                        </select>
                        <select class="form-control seyir-select-lg mr-50 mb-50 mb-md-0" v-model="statusFilter" v-on:change="$refs.table.refresh()">
                            <option v-for="opt in statusFilterOptions" :key="opt.value" :value="opt.value">{{opt.label}}</option>
                        </select>
                        <button class="btn btn-success mb-50 mb-md-0" v-on:click="$refs.table.refresh()">
                            <span class="material-icons-outlined align-middle mr-25" style="font-size:1rem">search</span>
                            Sorgula
                        </button>
                    </div>
                    <div class="seyir-action-group d-flex flex-wrap align-items-center">
                        <button class="btn btn-warning mr-50 mb-50 mb-md-0" v-on:click="openBulkRetrigger" v-b-tooltip.hover title="Bugün için sorgu başarısız veya dosya indirilemeyen sürücüleri tek tek yeniden sorgula">
                            <span class="material-icons-outlined align-middle mr-25" style="font-size:1rem">replay</span>
                            Hatalıları Yenile
                        </button>
                        <button class="btn btn-outline-primary mr-50 mb-50 mb-md-0" :disabled="exporting" v-on:click="exportExcel">
                            <span class="material-icons-outlined align-middle mr-25" style="font-size:1rem">file_download</span>
                            {{ exporting ? 'Hazırlanıyor...' : 'Excel' }}
                        </button>
                        <button class="btn btn-outline-info btn-icon mb-50 mb-md-0" v-b-modal.seyir-driver-info v-b-tooltip.hover title="Ekran kullanımı">
                            <span class="material-icons-outlined align-middle" style="font-size:1.1rem">help_outline</span>
                        </button>
                    </div>
                </div>
            </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard, BModal, BSpinner, VBModal, VBTooltip } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import moment from 'moment'

export default {
    components: {
        BCard,
        BModal,
        BSpinner,
    },
    directives: {
        'b-modal': VBModal,
        'b-tooltip': VBTooltip,
    },
    data() {
        return {
            fields: [],
            year: null,
            years: [],
            month: null,
            months: [
                { index: 1, name: 'Ocak' },
                { index: 2, name: 'Şubat' },
                { index: 3, name: 'Mart' },
                { index: 4, name: 'Nisan' },
                { index: 5, name: 'Mayıs' },
                { index: 6, name: 'Haziran' },
                { index: 7, name: 'Temmuz' },
                { index: 8, name: 'Ağustos' },
                { index: 9, name: 'Eylül' },
                { index: 10, name: 'Ekim' },
                { index: 11, name: 'Kasım' },
                { index: 12, name: 'Aralık' }
            ],
            daysOfMonth: [],
            statusFilter: 'All',
            statusFilterOptions: [
                { value: 'All', label: 'Tüm sürücüler' },
                { value: 'HasFailures', label: 'Sadece sorunlu günü olanlar' },
                { value: 'DownloadFailed', label: 'Dosya indirilemeyen günü olanlar' },
                { value: 'QueryFailed', label: 'Sorgu başarısız günü olanlar' },
                { value: 'NotQueried', label: 'Sorgu yapılmamış günü olanlar' },
                { value: 'NotConfigured', label: 'Yapılandırması eksik olanlar' },
                { value: 'DownloadedNotProcessed', label: 'Takograf işlenemeyen günü olanlar' },
            ],
            summary: null,
            exporting: false,
            bulkLoading: false,
            bulkRunning: false,
            bulkCancelRequested: false,
            bulkItems: [],
        }
    },
    computed: {
        todayLabel() {
            return moment().locale('tr').format('DD MMMM dddd')
        },
        bulkProcessedCount() {
            return this.bulkItems.filter(x => x.State === 'success' || x.State === 'fail').length
        },
        bulkSuccessCount() {
            return this.bulkItems.filter(x => x.State === 'success').length
        },
        bulkFailCount() {
            return this.bulkItems.filter(x => x.State === 'fail').length
        },
        bulkProgressPercent() {
            if (!this.bulkItems.length) return 0
            return Math.round((this.bulkProcessedCount / this.bulkItems.length) * 100)
        },
        bulkAllDone() {
            return this.bulkItems.length > 0 && this.bulkProcessedCount === this.bulkItems.length && !this.bulkRunning
        },
    },
    mounted() {
        this.getCurrentYear()
        this.configureYears()
        this.getCurrentMonth()
        this.configureDaysOfMonth(Date.now())
        this.configureFields()
        this.$root.$on('seyir-driver-retriggered', this.refreshTable)
    },
    beforeDestroy() {
        this.$root.$off('seyir-driver-retriggered', this.refreshTable)
    },
    methods: {
        refreshTable() {
            if (this.$refs.table) this.$refs.table.refresh()
        },
        configureDaysOfMonth(date) {
            this.daysOfMonth = []
            Array.from(Array(moment(date).daysInMonth()).keys()).forEach((d) => {
                let _date = moment(date).startOf("month").add(d, 'days')
                let _dateForName = _date.format('DD.MM.YYYY')
                this.daysOfMonth.push(_dateForName)
            })
        },
        getCurrentYear() {
            this.year = Number(moment().format('YYYY'))
        },
        configureYears() {
            let years = []
            let year = 2015
            while (year <= this.year) {
                years.push(year)
                year++
            }
            this.years = years
        },
        getCurrentMonth() {
            let current = moment().month() + 1
            this.month = this.months.find(m => m.index == current)?.index || 0
        },
        configureFields() {
            let todayStr = moment().format('DD.MM.YYYY')
            let fields = [
                { name: 'Sürücü', key: 'FullName', thClass: 'w-15', tdClass: 'text-nowrap' },
                { name: 'TC', key: 'IdentityNumber', thClass: 'w-10', tdClass: 'text-nowrap' },
                { name: 'Seyir Driver DataId', key: 'SeyirDriverDataId', thClass: 'w-10' },
                {
                    name: 'Analiz',
                    key: 'EmployeeAnalysisStatusLabel',
                    thClass: 'w-10',
                    tdClass: 'text-nowrap',
                    component: true,
                    componentOptions: { name: 'seyir-driver-download-trace/SeyirDriverAnalysisCell' },
                },
                {
                    name: 'Özet',
                    key: 'RowSummary',
                    thClass: 'w-5 text-center',
                    tdClass: 'text-center',
                    component: true,
                    componentOptions: { name: 'seyir-driver-download-trace/SeyirDriverRowSummary' },
                },
            ]
            this.daysOfMonth.forEach(d => {
                const isToday = d === todayStr
                fields.push({
                    name: moment(d, 'DD.MM.YYYY').locale('tr').format('DD ddd'),
                    key: `["Items","${d}"]`,
                    tooltip: moment(d, 'DD.MM.YYYY').locale('tr').format('DD MMMM YYYY dddd'),
                    thClass: 'table-vertical-text' + (isToday ? ' seyir-today-col-header' : ''),
                    tdClass: 'p-0 text-center border-left' + (isToday ? ' seyir-today-col' : ''),
                    component: true,
                    componentOptions: { name: "seyir-driver-download-trace/SeyirDriverDownloadTraceStatus" },
                })
            })
            this.fields = fields
        },
        async provider(data) {
            const response = await EmployeeOperationsApi.Tachograph.SeyirDriverFileDownloadReport({
                PaginationRequest: data,
                Month: this.month,
                Year: this.year,
                StatusFilter: this.statusFilter,
            })
            this.summary = response?.data?.Data?.Summary || null
            return response
        },
        onTableResfreh() {
            let date = moment(this.year + '-' + this.month, 'YYYY-MM')
            this.configureDaysOfMonth(date)
            this.configureFields()
        },
        async exportExcel() {
            try {
                this.exporting = true
                const response = await EmployeeOperationsApi.Tachograph.SeyirDriverFileDownloadReportExcel({
                    Month: this.month,
                    Year: this.year,
                    StatusFilter: this.statusFilter,
                })
                if ((response.headers['content-type'] || '').includes('application/json')) {
                    this.$result(null, { message: 'Dosya oluşturulamadı.' })
                    return
                }
                const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/octet-stream' })
                const contentDisposition = response.headers['content-disposition'] || ''
                const fileName = this.resolveFileNameFromContentDisposition(contentDisposition)
                    || `SeyirSuruciDosyaIndirmeTakip_${this.year}_${String(this.month).padStart(2, '0')}.xlsx`
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', fileName)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
            } catch (err) {
                this.$result(null, err)
            } finally {
                this.exporting = false
            }
        },
        async openBulkRetrigger() {
            this.bulkItems = []
            this.bulkLoading = true
            this.bulkRunning = false
            this.bulkCancelRequested = false
            this.$bvModal.show('seyir-bulk-retrigger')
            try {
                const res = await EmployeeOperationsApi.Tachograph.SeyirDriverFileDownloadTodayFailures()
                if (res?.data?.Success) {
                    this.bulkItems = (res.data.Data || []).map(x => ({ ...x, State: 'pending', Message: null }))
                } else {
                    this.$result(res)
                }
            } catch (err) {
                this.$result(null, err)
            } finally {
                this.bulkLoading = false
            }
        },
        bulkRowClass(item) {
            if (item.State === 'running') return 'seyir-row-running'
            if (item.State === 'success') return 'seyir-row-success'
            if (item.State === 'fail') return 'seyir-row-fail'
            return ''
        },
        cancelBulk() {
            this.bulkCancelRequested = true
        },
        async runBulk() {
            this.bulkRunning = true
            this.bulkCancelRequested = false
            for (const item of this.bulkItems) {
                if (this.bulkCancelRequested) break
                if (item.State === 'success' || item.State === 'fail') continue
                item.State = 'running'
                item.Message = null
                try {
                    const res = await EmployeeOperationsApi.Tachograph.SeyirTriggerDriverFileDownload(item.EmployeeId)
                    if (res?.data?.Success) {
                        item.State = 'success'
                        item.Message = res.data.Message || null
                    } else {
                        item.State = 'fail'
                        item.Message = res?.data?.Message || 'İşlem başarısız.'
                    }
                } catch (err) {
                    item.State = 'fail'
                    item.Message = err?.response?.data?.Message || err?.message || 'İstisna oluştu.'
                }
            }
            this.bulkRunning = false
            if (this.bulkProcessedCount > 0 && this.$refs.table) {
                this.$refs.table.refresh()
            }
        },
        onBulkModalHidden() {
            if (!this.bulkRunning && this.bulkProcessedCount > 0 && this.$refs.table) {
                this.$refs.table.refresh()
            }
        },
        resolveFileNameFromContentDisposition(contentDisposition) {
            if (!contentDisposition) return null
            const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)
            if (utf8Match && utf8Match[1]) return decodeURIComponent(utf8Match[1])
            const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/i)
            if (fileNameMatch && fileNameMatch[1]) return fileNameMatch[1]
            return null
        },
    }
}
</script>

<style>
.seyir-kpi-band .seyir-kpi-item {
    min-width: 110px;
    padding: 0.25rem 0.75rem;
    border-right: 1px solid rgba(0,0,0,0.06);
}
.seyir-kpi-band .seyir-kpi-item:last-child {
    border-right: none;
}
.seyir-kpi-band .seyir-kpi-value {
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.1;
}
.seyir-kpi-band .seyir-kpi-label {
    font-size: 0.75rem;
    color: #6e6b7b;
    text-transform: uppercase;
    letter-spacing: 0.02em;
}
.seyir-kpi-band .seyir-kpi-title {
    font-size: 0.8rem;
    font-weight: 600;
    color: #5e5873;
    text-transform: none;
    letter-spacing: 0;
}
.seyir-action-bar {
    gap: 0.5rem 0;
    width: 100%;
}
.seyir-action-bar .seyir-action-group {
    gap: 0;
}
.seyir-action-bar .seyir-select-sm {
    width: 110px;
    min-width: 100px;
}
.seyir-action-bar .seyir-select-lg {
    width: 240px;
    min-width: 200px;
}
.seyir-action-bar .btn {
    white-space: nowrap;
}
.seyir-legend {
    gap: 0.35rem;
}
.seyir-legend .seyir-legend-item {
    display: inline-flex;
    align-items: center;
    padding: 0.15rem 0.5rem;
    border-radius: 0.25rem;
    font-size: 0.78rem;
    font-weight: 600;
    line-height: 1.2;
}
.seyir-legend .seyir-legend-item .material-icons-outlined {
    font-size: 1rem;
    margin-right: 0.25rem;
}
/* Bulk Retrigger Modal */
.seyir-bulk-hero {
    background: linear-gradient(135deg, #f8f9ff 0%, #eef2ff 100%);
    border-bottom: 1px solid #e4e6ef;
}
.seyir-bulk-hero-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #5e5873;
    display: flex;
    align-items: center;
}
.seyir-bulk-hero-title .material-icons-outlined {
    color: #7367f0;
    font-size: 1.3rem;
}
.seyir-bulk-hero-subtitle {
    color: #6e6b7b;
    font-size: 0.88rem;
    margin-top: 0.15rem;
}
.seyir-bulk-progress {
    height: 8px;
    border-radius: 999px;
    background-color: rgba(115, 103, 240, 0.12);
}
.seyir-bulk-progress .progress-bar {
    border-radius: 999px;
    transition: width 300ms ease;
}
.seyir-bulk-chips {
    gap: 0.6rem;
}
.seyir-bulk-chip {
    flex: 1 1 140px;
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.55rem 0.85rem;
    border-radius: 0.5rem;
    background: #fff;
    border: 1px solid #e4e6ef;
}
.seyir-bulk-chip .material-icons-outlined {
    font-size: 1.6rem;
}
.seyir-bulk-chip-value {
    font-size: 1.3rem;
    font-weight: 700;
    line-height: 1;
}
.seyir-bulk-chip-label {
    font-size: 0.72rem;
    color: #6e6b7b;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-top: 0.15rem;
}
.seyir-bulk-chip-total .material-icons-outlined { color: #7367f0; }
.seyir-bulk-chip-success { background: #effbf5; border-color: #c9f2dc; }
.seyir-bulk-chip-success .material-icons-outlined,
.seyir-bulk-chip-success .seyir-bulk-chip-value { color: #28c76f; }
.seyir-bulk-chip-fail { background: #fef2f2; border-color: #fbd5d5; }
.seyir-bulk-chip-fail .material-icons-outlined,
.seyir-bulk-chip-fail .seyir-bulk-chip-value { color: #ea5455; }
.seyir-bulk-chip-pending .material-icons-outlined,
.seyir-bulk-chip-pending .seyir-bulk-chip-value { color: #ff9f43; }

.seyir-bulk-list {
    max-height: 48vh;
    overflow-y: auto;
}
.seyir-bulk-row {
    display: grid;
    grid-template-columns: 32px 28px minmax(180px, 2fr) minmax(180px, 1.4fr) minmax(180px, 1.4fr);
    gap: 0.75rem;
    align-items: center;
    padding: 0.7rem 1rem;
    border-bottom: 1px solid #f3f2f7;
    transition: background-color 250ms ease;
}
.seyir-bulk-row:hover {
    background-color: #f8f8fb;
}
.seyir-bulk-row.seyir-row-running {
    background-color: #eef2ff;
    box-shadow: inset 3px 0 0 #7367f0;
}
.seyir-bulk-row.seyir-row-success {
    box-shadow: inset 3px 0 0 #28c76f;
}
.seyir-bulk-row.seyir-row-fail {
    background-color: #fef5f5;
    box-shadow: inset 3px 0 0 #ea5455;
}
.seyir-bulk-row-index {
    color: #b9b9c3;
    font-weight: 600;
    text-align: center;
    font-size: 0.85rem;
}
.seyir-bulk-row-state-icon {
    display: flex;
    align-items: center;
    justify-content: center;
}
.seyir-bulk-row-state-icon .material-icons-outlined {
    font-size: 1.35rem;
}
.seyir-bulk-row-name {
    font-weight: 600;
    color: #5e5873;
}
.seyir-bulk-row-meta {
    font-size: 0.78rem;
    color: #6e6b7b;
    margin-top: 0.15rem;
}
.seyir-bulk-row-meta b {
    color: #5e5873;
    font-weight: 600;
}
.seyir-bulk-row-status-old,
.seyir-bulk-row-result {
    min-width: 0;
}
.seyir-bulk-row-result .badge {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
}
.seyir-today-col-header {
    background-color: #fff3cd !important;
}
.seyir-today-col {
    background-color: #fffbe6 !important;
}
</style>
